import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';
import { GuardDataKeys } from '../constants/guard-constants';
import { RouteConstants } from '../../constants/routes';

@Injectable({
    providedIn: 'root',
})
export class UserRoleAuthGuard {
    constructor(
        private readonly userStateService: UserStateService,
        private readonly router: Router,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const permittedUserRoles =
            route.data[GuardDataKeys.PERMITTED_USER_ROLES];
        return permittedUserRoles.includes(this.userStateService.getRole())
            ? of(true)
            : of(
                  this.router.createUrlTree([
                      RouteConstants.Dashboard.getRootUrl(),
                  ]),
              );
    }
}
